import { defaultConfig as defaultConfigBase } from '@chakra-ui/react/preset'
import {
  createSystem as createSystemBase,
  defineConfig as defineConfigBase,
  defineGlobalStyles as defineGlobalStylesBase,
} from '@chakra-ui/react/styled-system'

import { rootCssVars } from 'theme/generated/design-tokens'
import { buttonRecipe } from 'theme/recipes/button.recipe'
import { statusBadgeRecipe } from 'theme/recipes/statusBadge.recipe'
import { surfaceCardRecipe } from 'theme/recipes/surfaceCard.recipe'

type GlobalStyles = Record<string, Record<string, string>>

type ThemeConfig = {
  globalCss: GlobalStyles
  strictTokens?: boolean
  theme: {
    recipes?: Record<string, unknown>
    tokens: {
      radii: Record<string, { value: string }>
    }
  }
}

const defaultConfig = defaultConfigBase as unknown
const createSystem = createSystemBase as unknown as (base: unknown, configuration: ThemeConfig) => unknown
const defineConfig = defineConfigBase as unknown as (configuration: ThemeConfig) => ThemeConfig
const defineGlobalStyles = defineGlobalStylesBase as unknown as (styles: GlobalStyles) => GlobalStyles

// All design-token CSS custom properties are generated from the single source in
// packages/design-tokens (see theme/generated/design-tokens.ts). The private
// --base-* palette and the public --theme-*/feedback/admin roles all live there;
// this file only injects them and maps html/body to the theme roles.
const globalCss = defineGlobalStyles({
  ':root': { ...rootCssVars },
  html: {
    bg: 'var(--theme-background)',
    color: 'var(--theme-text-color)',
  },
  body: {
    bg: 'var(--theme-background)',
    color: 'var(--theme-text-color)',
  },
})

const config = defineConfig({
  strictTokens: true,
  theme: {
    recipes: {
      button: buttonRecipe,
      statusBadge: statusBadgeRecipe,
      surfaceCard: surfaceCardRecipe,
    },
    tokens: {
      radii: {
        md: { value: '12px' },
        xl: { value: '20px' },
      },
    },
  },
  globalCss,
})

export const chakraSystem = createSystem(defaultConfig, config)
